<template>
  <div class="wrapper">
    <div class="d-flex align-center justify-center">
      <LocationGroupAddButton
        :showAddModal="showAddModal"
        :showGroupBulkModal="showGroupBulkModal"
        :showGroupAndLocationBulkModal="showGroupAndLocationBulkModal"
      />
      <v-btn
        @click="showImportModal"
        class="button caption"
        color="primary"
        small
      >
        <v-icon small class="mr-1">input</v-icon>
        グループ読み込み
      </v-btn>
    </div>
    <LocationGroupAddModal
      v-model="isShowAddModal"
      :form="form"
      :simulation-location-groups="simulationLocationGroups"
    />
    <LocationGroupImportModal
      v-if="isShowImportModal"
      v-model="isShowImportModal"
      :form="form"
      :simulation-location-groups="simulationLocationGroups"
    />
    <LocationGroupBulkAddModal
      v-if="isShowGroupBulkAddModal"
      v-model="isShowGroupBulkAddModal"
      :form="form"
      :simulation-location-groups="simulationLocationGroups"
    />
    <LocationGroupAndLocationBulkAddModal
      v-if="isShowGroupAndLocationBulkAddModal"
      v-model="isShowGroupAndLocationBulkAddModal"
      :form="form"
      :geocoder="geocoder"
      :simulation-location-groups="simulationLocationGroups"
    />
  </div>
</template>

<script>
import LocationGroupAddButton from './SimulationLocationGroupAddButton'
import LocationGroupImportModal from './SimulationContentDeliveryLocationGroupImportModal'
import LocationGroupAddModal from './SimulationContentDeliveryLocationGroupAddModal'
import LocationGroupBulkAddModal from './SimulationContentDeliveryLocationGroupBulkAddModal'
import LocationGroupAndLocationBulkAddModal from './SimulationContentDeliveryLocationGroupAndLocationBulkAddModal'
import { MenuSetting } from '@/models/Simulation'
import { getGeocoder } from '@/models/Location'

export default {
  name: 'SimulationContentDeliverySidebarDeliveryPointSetting',
  components: {
    LocationGroupAddButton,
    LocationGroupImportModal,
    LocationGroupAddModal,
    LocationGroupBulkAddModal,
    LocationGroupAndLocationBulkAddModal,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    simulationLocationGroups: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      geocoder: getGeocoder(),
      items: [
        { text: 'グループ登録', callback: () => this.showAddModal() },
        { text: 'グループ一括登録', callback: () => this.showBulkModal() },
      ],
      isShowImportModal: false,
      isShowAddModal: false,
      isShowGroupBulkAddModal: false,
      isShowGroupAndLocationBulkAddModal: false,
    }
  },
  methods: {
    isAddable() {
      if (this.form.deliverySetting.menuSetting.isUpperLimit()) {
        this.$confirm(MenuSetting.VALIDATION_MESSAGES.upperLimit, {
          onlyOk: true,
          okText: '閉じる',
        })
        return false
      }
      return true
    },
    showImportModal() {
      this.isShowImportModal = this.isAddable()
    },
    showAddModal() {
      this.isShowAddModal = this.isAddable()
    },
    showGroupBulkModal() {
      this.isShowGroupBulkAddModal = this.isAddable()
    },
    showGroupAndLocationBulkModal() {
      this.isShowGroupAndLocationBulkAddModal = this.isAddable()
    },
  },
}
</script>

<style scoped>
.wrapper {
  width: 100%;
  border-bottom: 1px solid #d5d5d5;
}

.button {
  width: 100%;
  padding: 0;
  margin: 0;
}
</style>
